import React, { Component } from 'react';
import TextButton from 'components/TextButton';
import './GiphyItem.css';

class GiphyItem extends Component {
  render() {
    const { gif, onGifSelect, ...otherProps } = this.props;
    const gifSize = gif.images.downsized || gif.images.fixed_width;
    const url = gifSize.url;
    return (
      <div className="giphy-item-container">
        <TextButton onClick={() => onGifSelect(url)} {...otherProps}>
          <img
            className="animated-gif"
            src={url}
            alt={gif.title || 'Animated GIF'}
          />
        </TextButton>
      </div>
    );
  }
}

export default GiphyItem;
